import React from "react";
import {
  Box,
  Popper,
  Typography,
  List,
  Fade,
  ClickAwayListener,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
} from "@mui/material";
import color from "../utils/Colors";
import { menuData } from "../utils/Data";
import { useNavigate } from "react-router-dom";
import { SvgIconComponent } from "@mui/icons-material";
import { useUser } from "../../services/Context/UserContext";
import { roleMenus } from "../utils/RoleMenus";
interface CustomPopperProps {
  anchorEl: HTMLElement | null;
  open: boolean;
  handleClose: (event: MouseEvent | TouchEvent) => void;
}

const CustomPopper: React.FC<CustomPopperProps> = ({
  anchorEl,
  open,
  handleClose,
}) => {
  const navigate = useNavigate();

  const handleNavigation = (route: string) => {
    navigate(route);
  };

  const handleItemClick = (item: any) => {
    if (item.label === "Log Out") {
      localStorage.clear();
    }
    handleNavigation(item.route);
    handleClose(new MouseEvent("click"));
  };
  const { user } = useUser();
  const role = user?.role?.toLowerCase() || "student";

  const currentMenu = roleMenus[role] || "student";
  return (
    <ClickAwayListener onClickAway={handleClose}>
      <Popper open={open} anchorEl={anchorEl} transition sx={{ zIndex: 10000 }}>
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Box
              sx={(theme) => ({
                border: "1px solid",
                borderColor: color.borderColor,
                borderRadius: "12px",
                p: 2,
                pb: 3,
                pl: 0,
                pr: 0,
                color: color.firstColor,
                m: 1,
                bgcolor:
                  theme.palette.mode === "light"
                    ? "rgba(255, 255, 255, 0.4)"
                    : "rgba(0, 0, 0, 0.4)",
                backdropFilter: "blur(20px)",
                overflow: "hidden",
                width: 260,
                boxShadow: "0 20px 20px rgba(0, 0, 0, 0.20)",
              })}
            >
              <Box
                sx={{
                  height: "30px",
                  width: "100%",
                  boxShadow: "0 -2px 20px rgba(0, 0, 0, 0.2)",
                  position: "absolute",
                  bottom: 0,
                  bgcolor: color.firstColor,
                }}
              ></Box>
              <Box
                sx={{
                  bgcolor: color.firstColor,
                  p: 1,
                  m: -2,
                  mb: 0,
                  pl: 4,
                  color: "white",
                  textAlign: "left",
                  boxShadow: "0 2px 20px rgba(0, 0, 0, 0.2)",
                }}
              >
                <Typography variant="subtitle1">Name: {user?.name}</Typography>
                <Typography variant="subtitle2">
                  Email ID: {user?.email}
                </Typography>
              </Box>
              <div>
                {currentMenu.map((section: any, index: number) => (
                  <List
                    key={index}
                    sx={{
                      borderBottom: "solid 1px",
                      borderColor: color.borderColor,
                      fontSize: "16px",
                    }}
                  >
                    {section.items.map((item: any, i: number) => {
                      const Icon = item.icon as SvgIconComponent;
                      return (
                        <div key={i}>
                          <ListItemButton
                            sx={{ p: 0.5, borderRadius: "30px", pl: 2 }}
                            key={i}
                            onClick={() => handleItemClick(item)}
                          >
                            <ListItemIcon
                              sx={{
                                minWidth: "0px",
                                color: color.firstColor,
                                mr: 2,
                              }}
                            >
                              <Icon />
                            </ListItemIcon>
                            <ListItemText
                              sx={{ color: color.firstColor }}
                              primary={item.label}
                            />
                          </ListItemButton>
                          {i === 3 || i === 6 ? (
                            <Divider sx={{ background: color.firstColor }} />
                          ) : (
                            ""
                          )}
                        </div>
                      );
                    })}
                  </List>
                ))}
              </div>
            </Box>
          </Fade>
        )}
      </Popper>
    </ClickAwayListener>
  );
};

export default CustomPopper;
